/* eslint-disable no-undefined */
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
// Mui imports > move to modern
import { ThemeProvider } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import OpenInNew from "@mui/icons-material/OpenInNew";
// Limitless Imports
import { createTheme } from "@limitless/portal";
import { useNavigation } from "../../hooks/navigation/NavigationContext";
import { useTranslation } from "@limitless/common/hooks";
import { useNotificationContext } from "@limitless/common/hooks";
import { createPortalURL, getPortalDetails } from "../../utils/PortalHelper";
import { useExpertMessageContext, useExpertProfileContext, useAuthenticationContext, useTaskListFilter } from "../../../expert";
import { POLICY_APP_INFO } from "../../utils/CommonPolicyConstants";
import OkCancelDialog from "../../components/dialogs/ok-cancel-dialog/OkCancelDialog";
// Modern Imports
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import Menu from "@limitless/modern/navigation/menu/Menu";
import Divider from "@limitless/modern/data-display/divider/Divider";
import Typography from "@limitless/modern/data-display/typography/Typography";
// Icon Imports
import DotsIcon from "@limitless/icons/EllipsisVertical";
const SettingsMenu = () => {
  const [openSignOutDialog, setOpenSignOutDialog] = React.useState(false);
  const [settingsMenuAnchorEl, setSettingsMenuAnchorEl] = React.useState(null);
  const {
    navigate
  } = useNavigation();
  const {
    profile,
    canUserAccess
  } = useExpertProfileContext();
  const {
    signOut
  } = useAuthenticationContext();
  const {
    addSuccessNotification
  } = useNotificationContext();
  const {
    t
  } = useTranslation();
  const {
    message
  } = useExpertMessageContext();
  const {
    clearFilter
  } = useTaskListFilter();
  const originalTheme = createTheme();
  const settingsMenuOpen = Boolean(settingsMenuAnchorEl);
  const isManager = canUserAccess(POLICY_APP_INFO);
  const {
    portals,
    cmPortal
  } = getPortalDetails(isManager, canUserAccess);
  const handleSettingsMenuClick = event => {
    setSettingsMenuAnchorEl(event.currentTarget);
  };
  const handleSettingsMenuClose = () => {
    setSettingsMenuAnchorEl(null);
  };
  const handlePortalClicked = (portal, destinationSuffix) => {
    window.open(createPortalURL(portal, destinationSuffix), "_blank");
    handleSettingsMenuClose();
  };
  const renderPortals = portalList => {
    return portalList.map(portal => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: portal.portalName,
        onClick: () => handlePortalClicked(portal),
        id: portal.portalName
      }, /*#__PURE__*/React.createElement(ListItemText, {
        primary: t(`${portal.title}`)
      }), /*#__PURE__*/React.createElement(OpenInNew, {
        edge: "end"
      }));
    });
  };
  const handleCloseDialog = () => {
    setOpenSignOutDialog(false);
  };
  const handleSignOut = React.useCallback(() => {
    clearFilter();
    signOut();
    navigate("/");
  }, [profile]);
  const showEditProfile = true;
  const handleSignOutClick = () => {
    setOpenSignOutDialog(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(DotsIcon, null),
    label: "",
    id: "profileHeaderMenuButton",
    "aria-controls": settingsMenuOpen ? "settings-menu" : undefined,
    "aria-haspopup": "true",
    "aria-expanded": settingsMenuOpen ? "true" : undefined,
    onClick: handleSettingsMenuClick
  }), /*#__PURE__*/React.createElement(Menu, {
    id: "settings-menu",
    anchorEl: settingsMenuAnchorEl,
    open: settingsMenuOpen,
    onClose: handleSettingsMenuClose,
    MenuListProps: {
      "aria-labelledby": "profileHeaderMenuButton"
    }
  }, portals.length > 0 && renderPortals(portals), cmPortal && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => handlePortalClicked(cmPortal, `find/${message.messageId}`),
    id: "profileHeaderMenuOpenMessage",
    disabled: message.messageId ? false : true
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Open Message")
  }), /*#__PURE__*/React.createElement(OpenInNew, null)), cmPortal && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => {
      navigate("/settings");
      handleSettingsMenuClose();
    },
    id: "profileHeaderMenuSettings"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Settings")
  })), showEditProfile && /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: profile.userName,
    onCopy: () => {
      addSuccessNotification(t("User Name copied to clipboard"));
      handleSettingsMenuClose();
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    id: "copyUserName"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Copy User Name")
  }))), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => {
      handleSignOutClick();
      handleSettingsMenuClose();
    },
    id: "profileHeaderMenuSignOut"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Sign Out")
  }))), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: originalTheme
  }, /*#__PURE__*/React.createElement(OkCancelDialog, {
    key: 0,
    open: openSignOutDialog,
    title: "Sign Out",
    onOKClick: handleSignOut,
    okLabel: "Confirm",
    okId: "confirmSignOutButton",
    onCancelClick: handleCloseDialog,
    cancelId: "cancelSignOutButton"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    id: "alert-dialog-title"
  }, t("Are you sure you want to Sign Out?")))));
};
SettingsMenu.propTypes = {};
export default SettingsMenu;